'use client';

import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { SessionContext } from '@benzinga/session-context';
import { QuotesManager, Security, BullBearStatements } from '@benzinga/quotes-manager';
import { safeUnwrapOrThrow } from '@benzinga/safe-await';

const FIVE_MINUTES = 5 * 60 * 1000;

export const BULLS_BEARS_QUERY_KEY = 'bullsSayBearsSay' as const;

export const useBullsSayBearsSayQuery = (symbol: Security) => {
  const session = useContext(SessionContext);

  return useQuery<BullBearStatements[]>({
    enabled: !!symbol,
    queryFn: async () => {
      const result = await session.getManager(QuotesManager).getBullSayBearSay([symbol]);

      return safeUnwrapOrThrow(result) ?? [];
    },
    queryKey: [BULLS_BEARS_QUERY_KEY, symbol],
    staleTime: FIVE_MINUTES,
  });
};
